export function initAnchor() {
    const header = document.querySelector<HTMLElement>('.header');
    const sidebarItemsContainer = document.querySelector<HTMLElement>('.sidebar-menu__items');
    const mainSidebar = document.querySelector<HTMLElement>('.main-sidebar');

    // === Получаем точный контейнер для скролла body SimpleBar ===
    function getScrollContainer(): HTMLElement | Window {
        const bodySimplebar = document.querySelector('body[data-simplebar]');
        if (!bodySimplebar) return window;

        const wrapper = bodySimplebar.querySelector(
            '.simplebar-wrapper > .simplebar-mask > .simplebar-offset > .simplebar-content-wrapper'
        );
        console.log(wrapper)
        return wrapper ?? window;
    }

    const scrollContainer = getScrollContainer();

    function getScrollTop(): number {
        return scrollContainer === window ? window.scrollY : (scrollContainer as HTMLElement).scrollTop;
    }

    function scrollToPosition(top: number) {
        if (scrollContainer === window) {
            window.scrollTo({ top, behavior: 'smooth' });
        } else {
            (scrollContainer as HTMLElement).scrollTo({ top, behavior: 'smooth' });
        }
    }

    function setActiveLink(targetId: string) {
        const links = document.querySelectorAll<HTMLAnchorElement>('.sidebar-menu__link');
        links.forEach(l => l.classList.remove('active'));

        const activeLink = document.querySelector<HTMLAnchorElement>(`.sidebar-menu__link[href="#${targetId}"]`);
        activeLink?.classList.add('active');

        // Прокрутка горизонтально в мобилке
        if (window.innerWidth < 1140 && sidebarItemsContainer && activeLink) {
            const linkLeft = activeLink.offsetLeft;
            sidebarItemsContainer.scrollTo({ left: linkLeft - 18, behavior: 'smooth' });
        }
    }

    // === Делегирование кликов на sidebar ===
    sidebarItemsContainer?.addEventListener('click', (e) => {
        const link = (e.target as HTMLElement).closest<HTMLAnchorElement>('.sidebar-menu__link');
        if (!link) return;

        e.preventDefault();
        const targetId = link.getAttribute('href')?.replace('#', '');
        if (!targetId) return;

        const targetEl = document.getElementById(targetId);
        if (!targetEl) return;

        const headerHeight = header?.offsetHeight ?? 0;
        const sidebarHeight = (window.innerWidth < 1140 && mainSidebar) ? mainSidebar.offsetHeight : 0;
        const offset = headerHeight + (window.innerWidth < 1140 ? 0 : 20) + sidebarHeight;

        // Позиция секции относительно контейнера SimpleBar
        const containerEl = scrollContainer === window ? document.documentElement : scrollContainer as HTMLElement;
        const targetTop = targetEl.offsetTop - offset;

        scrollToPosition(targetTop);
        setActiveLink(targetId);
    });

    // === Обработчик скролла для подсветки ===
    const handleScroll = () => {
        const headerHeight = header?.offsetHeight ?? 0;
        const sidebarHeight = (window.innerWidth < 1140 && mainSidebar) ? mainSidebar.offsetHeight : 0;
        const offset = headerHeight + 30 + sidebarHeight;

        let currentId: string | null = null;
        const links = document.querySelectorAll<HTMLAnchorElement>('.sidebar-menu__link');

        const scrollTop = getScrollTop();

        links.forEach(link => {
            const targetId = link.getAttribute('href')?.replace('#', '');
            if (!targetId) return;

            const targetEl = document.getElementById(targetId);
            if (!targetEl) return;

            // Позиция секции относительно контейнера SimpleBar
            const sectionTop = scrollContainer === window
                ? targetEl.offsetTop
                : targetEl.offsetTop - (scrollContainer as HTMLElement).offsetTop;

            if (scrollTop + offset >= sectionTop) {
                currentId = targetId;
            }
        });

        if (currentId) setActiveLink(currentId);
    };

    // === Подписка на скролл ===
    if (scrollContainer === window) {
        window.addEventListener('scroll', handleScroll);
    } else {
        (scrollContainer as HTMLElement).addEventListener('scroll', handleScroll);
    }

    // === Инициализация активного пункта сразу ===
    handleScroll();
}
